import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBankofamericaComponent } from './simple-icons-bankofamerica.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBankofamericaComponent ],
    exports:      [ SimpleIconsBankofamericaComponent ],
    bootstrap:    []
})
export class SimpleIconsBankofamericaModule {}
